<template>
  <div
    id="app"
    :class="{
      'bg-2': bgType == 2,
    }"
  >
    <router-view />
    <portal-target name="modalPortal" class="portal"></portal-target>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgType: 0,
    };
  },
  watch: {
    "$route.meta"() {
      // console.log(this.$route.meta);
      this.bgType = +this.$route.meta.bgType || 0;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
#app {
  display: flex;
  flex-direction: column;
  flex: 1;
  background: url(./assets/bg.png) no-repeat center center;
  background-size: 100% 100%;
  height: 100%;

  &.bg-2 {
    background-image: url(./assets/bg-2.png);
  }
}
html {
  height: 100%;
}
.portal {
  height: 0;
  width: 0;
}
</style>
